<template>
  <div>
    <Loader :loading="loading" />
    <div
      class="head"
      v-bind:style="'background-image: url(' + tvShow.background_image + ');'"
      v-if="!loading"
    >
      <div class="container-fluid tvshow">
        <div class="row">
          <div class="col-xs-12 col-md-12">
            <button class="back" href="#" @click="back()">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          <div class="col-xs-12 col-md-2">
            <div class="left1 d-none d-md-block">
              <ul class="rates">
                <li>
                  <a class="rate" href="#">
                    <i class="fa fa-star" aria-hidden="true"></i>{{ tvShow.rating }}
                  </a>
                </li>
                <li>
                  <a class="time">{{ /* TODO: time here */ }}</a>
                </li>
              </ul>
              <ul class="divleft d-none d-md-block" v-if="tvShow.directory">
                Dircetor:
                <li>
                  <router-link :to="'/?title=' + tvShow.director">
                    {{ tvShow.director }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-md-2">
            <div class="mainperaa d-md-none">
              <h2 class='mt-0'>TV SHOW: {{ tvShow.title }}</h2>
              <h3 v-if="tvShow.secondary_title !== ''" class="mb-0">
                ({{ tvShow.secondary_title }})
              </h3>
            </div>
            <div class="left2 mb-xl-5">
              <img :src="tvShow.avatar" @error="imageAlt" />
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="mainperaa">
              <div class="d-md-none mb-3">
                <el-rate
                  :value="tvShow.rating / 2"
                  disabled
                  show-score
                  text-color="#ff9900"
                  :score-template="tvShow.rating + ' rating'">
                </el-rate>
              </div>
              <router-link
                v-for='genre in tvShow.genre.split("/")'
                :key='genre'
                class="mp-top-genre"
                :to="{name: 'genre', params: {genre}}"
              >
                {{ genre }}
              </router-link>
              <h2 class='d-none d-md-block'>TV SHOW: {{ tvShow.title }}</h2>
              <h3 v-if="tvShow.secondary_title !== ''" class=' d-none d-md-block'>
                ({{ tvShow.secondary_title }})
              </h3>
              <ul class="btnss mt-3 mt-md-0 mb-0">
                <li>
                  <a class="pcc" href="#">PG-13</a>
                </li>
                <li>
                  <a class="hdd" href="#">HD</a>
                </li>
                <li>
                  <a href="#">
                    <img :src="asset('/newlayout/images/count.png')" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img style="width: 50px; margin-left: 7px" :src="asset('/premium.png')" />
                  </a>
                </li>
              </ul>
              <p>
                {{ tvShow.description }}
              </p>
              <ul class="lastbtnss">
                <li v-if="tvShow.trailer">
                  <el-button type="primary" 
                    icon="el-icon-video-camera-solid" 
                    data-toggle="modal" 
                    data-target="#movieTrailer"
                  >
                    Watch Trailer
                  </el-button>
                </li>
                <li>
                  <el-button 
                    type="primary"
                    :plain="tvShow.is_favorite ? true : false" 
                    :icon="'fa' + (tvShow.is_favorite ? ' fa-heart' : ' fa-heart-o')" 
                    @click="tvShow.is_favorite ? removeFav() : addToFav()"
                    :title="(tvShow.is_favorite ? 'Remove from' : 'Add to') + ' favourite'"
                  >
                    {{ tvShow.is_favorite ? 'Favorite' : 'Favorite' }}
                  </el-button>
                </li>
                <li>
                  <el-button 
                    type="primary"
                    :plain="tvShow.watch_later ? true : false" 
                    icon="fa fa-clock-o" 
                    @click="tvShow.watch_later ? removeWatchLater() : addToWatchLater()"
                    :title="(tvShow.watch_later ? 'Remove from' : 'Add to') + ' Watch Later'"
                  >
                    {{ 'Watch Later' }}
                  </el-button>
                </li>
                <li>
                  <el-button type="primary" icon="fa fa-file-text-o"
                    @click='reportDialog.active = true'
                  >
                    Report
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /TvShow Details -->

        <div class="row">
          <div class="col-12 col-md-2"></div>
          <div class="col-12 col-md-10">
            <div class="row pb-3">
              <div class="col-6">
                <h2 class='title-1' v-if='season'>
                  EPISODES</h2>
              </div>
              <div class="col-6 text-right">
                <el-select v-model="activeSeason" placeholder="Select Season" @change="switchSeason()">
                  <el-option :label="s.title" :value="s.season_id" v-for='s in tvShow.seasons' :key='s.season_id'>
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- /episodes heading -->
            <div class="row pb-5 pt-1">
              <EpisodeGrid
                v-for="(episode, index) in season.episodes"
                :key="index"
                :title='episode.title'
                :url="episode.episode_id + '/play'"
                :avatar="episode.avatar"
              />
            </div>
            <!-- /episodes -->

            <h2 class='title-1' v-if='actors && actors.length'>
              CAST</h2>
            <div class="row pb-5 pt-1" v-if="actors && actors.length">
              <ActorGrid v-for="actor in actors" :key='actor.actor_id'
                :name='actor.name'
                :avatar='actor.image'
              />
            </div>
            <!-- /cast -->

            <h2 class='title-1' v-if='others && others.length'>RELEVANT MOVIES</h2>
            <div class="row pb-5" v-if='others && others.length'>
              <FilmGrid v-for="(other, index) in others" :key='index'
                :id='other.tvshow_id'
                type='tv-show'
                :url="'/tv-show/' + other.tvshow_id" 
                :avatar='other.avatar'
                :secondaryTitle='other.secondary_title'
                :title="other.title"
                :year="other.year"
                :rate='other.rating'
                :watchlater='other.watch_later_count'
                :favorite='other.favorite_count'
                grid-class='col-lg-2 col-md-3 col-6 col-sm-4'
              />
            </div>
            <!-- /relevent movies -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <Modal title="Movie Trailer" id="movieTrailer" minWidth="700px" style="z-index: 10000000;">
      <iframe
        width="100%"
        height="409"
        :src="tvShow.trailer + '?version=3&enablejsapi=1&&playerapiid=ytplayer'"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        allowscriptaccess="always"
      ></iframe>
    </Modal>

    <report-dialog 
      :active='reportDialog.active'
      :id='reportDialog.id'
      :type='reportDialog.type'
      @close='reportDialog.active = false'
    />
  </div>
</template>


<style>
@import "../assets/inner-page-style.css";
</style>

<script>
import Modal from "../components/bootstrap/Modal";
import Loader from "../components/Loader";
import $ from "jquery";
import { authRequest } from "../app/helpers";
import toastr from "toastr";
import FilmGrid from '../components/FilmGrid'
import ActorGrid from '../components/ActorGrid'
import EpisodeGrid from '../components/EpisodeGrid'
import ReportDialog from '../components/ReportDialog';

export default {
  name: "TvShow",
  data() {
    return {
      loading: true,
      actors: [],
      hiddenActors: [],
      tvShow: [],
      background: [],
      others: [],
      season: [],
      sort: '',
      activeSeason: '',
      reportDialog: {
        active: false,
        id: null,
        type: 'tvshow',
      },
    };
  },

  components: {
    Modal,
    Loader,
    ActorGrid,
    FilmGrid,
    ReportDialog,
    EpisodeGrid
  },

  mounted() {
    this.$store.commit("bodyClass", "details-main tvshow");

    this.setQuery();
    this.getMovie();

    $(document).ready(function() {
      $(".at-catsholder").hide();
      var check = 0;
      $(document.body).one("click", ".at-btnshowmore", function() {
        if (check == 0) {
          $(".at-catsholder").slideToggle();
          $(".at-btnshowmore").html(
            '<i class="fa fa-arrow-up" style="margin-right:8px"></i><span>Hide</span>'
          );
          check = 1;
        } else {
          $(".at-catsholder").slideToggle();
          $(".at-btnshowmore").html(
            '<i class="fa fa-arrow-down"></i> <span>Show More</span>'
          );
          check = 0;
        }
      });

      $("#movieTrailer").on('hidden.bs.modal', function () {
        $(this).find('iframe').filter(function(){
          this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        });
      })
    });
  },

  methods: {
    back() {
      return this.$router.go(-1)
    },

    async getMovie() {
      this.loading = true;

      const req = await authRequest(
        this.$router,
        "/tv-show/" + this.$route.params.id 
        + '?sort=' + this.sort + '&season=' + this.activeSeason
      );

      if (req) {
        this.loading = false;
        this.tvShow = req.tvShow;
        // this.background = req.background
        this.others = req.others;
        this.season = req.currentSeason;
        this.activeSeason = this.season.season_id;

        if (this.tvShow.actors && this.tvShow.actors.length > 0) {
          this.actors = this.tvShow.actors.slice(0, 6);
          this.hiddenActors = this.tvShow.actors.splice(6);
        }
      }
    },

    async addToFav() {
      const req = await authRequest(
        this.$router,
        "/tv-show/" + this.$route.params.id + "/favorite",
        {},
        "post"
      );

      if (req) {
        if (req.status == 1) {
          toastr.success(req.message);
          this.tvShow.is_favorite = true;
        } else {
          toastr.warning(req.message);
        }
      }
    },

    async removeFav() {
      const req = await authRequest(
        this.$router,
        "/tv-show/" + this.$route.params.id + "/favorite",
        {_method: 'DELETE'},
        "post"
      );

      if (req) {
        if (req.status == 1) {
          toastr.success(req.message);
          this.tvShow.is_favorite = false;
        } else {
          toastr.warning(req.message);
        }
      }
    },

    async addToWatchLater() {
      const req = await authRequest(
        this.$router,
        "/tv-show/" + this.$route.params.id + "/watch_later",
        {},
        "post"
      );

      if (req) {
        if (req.status == 1) {
          toastr.success(req.message);
          this.tvShow.watch_later = true;
        } else {
          toastr.warning(req.message);
        }
      }
    },

    async removeWatchLater() {
      const req = await authRequest(
        this.$router,
        "/tv-show/" + this.$route.params.id + "/watch_later",
        {_method: 'DELETE'},
        "post"
      );

      if (req) {
        if (req.status == 1) {
          toastr.success(req.message);
          this.tvShow.watch_later = false;
        } else {
          toastr.warning(req.message);
        }
      }
    },


    setQuery() {
      const route = this.$route;
      this.sort = route.query.sort || '';
      this.activeSeason = route.query.season || '';
    },
    

    switchSeason() {
      const query = {
        ...this.$route.query,
        season: this.activeSeason
      };

      this.$router.push({query});
    },

    imageAlt(e) {
      e.target.src = 'https://via.placeholder.com/185x270.png?text=No+Thumbnail';
    },
  },

  watch: {
    $route(t, f) {
      this.setQuery();
      this.getMovie();
    }
  },

  computed: {}
};
</script>

<style lang="scss" scoped>
.head {
  background-repeat: no-repeat; 
  background-size: contain; 
  min-height: 485px;
  background-position: top center;
  @media (max-width: 768px) {
    background-size: auto;
  }
}
</style>